export default "__VITE_ASSET__iT5CqiFK__"